import React from 'react';
import { BellIcon, Button } from '@onsolve/onsolve-ui-components';
import styles from './NotificationButton.module.scss';
export const NotificationButton = ({ handleTogglePopover, count, ariaLabel }) => {
    return (<Button id="notifications" className={styles.button} color="transparent" onClick={handleTogglePopover} aria-label={ariaLabel}>
            <BellIcon size="lg" color="white"/>
            {!!count && (<span className={styles.button_counter} data-testid="NotificationButton">
                    {count}
                </span>)}
        </Button>);
};
